import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ctas"
}
const _hoisted_2 = { class: "srOnly" }

import { SailingStatus, Button } from '../../Atoms';
import { InfoCard } from '../../Molecules';
import { StatusDetailsTabView } from '../../Organisms';
import { RteContentType, SailingStatusType } from '../../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'SailingTabView',
  props: {
    status: {},
    statusHeading: {},
    rteContent: {},
    showAlternativeCta: { type: Boolean },
    showRefundCta: { type: Boolean },
    refundClick: { type: Function },
    findAlternativeClick: { type: Function }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StatusDetailsTabView), { "rte-content": _ctx.rteContent }, {
    header: _withCtx(() => [
      _createVNode(_unref(SailingStatus), {
        "sailing-status": _ctx.status,
        "status-text": _ctx.statusHeading
      }, null, 8, ["sailing-status", "status-text"])
    ]),
    infoCard: _withCtx(() => [
      (_ctx.status === _unref(SailingStatusType).Normal)
        ? (_openBlock(), _createBlock(_unref(InfoCard), {
            key: 0,
            "icon-name": "statusNormal",
            text: _ctx.$t('All sailings normal today text'),
            lg: true,
            "background-color": '#DCF1D9'
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    ctas: _withCtx(() => [
      (_ctx.showAlternativeCta || _ctx.showRefundCta)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.showRefundCta)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  outline: true,
                  role: "link",
                  label: _ctx.$t('Request a refund'),
                  onClick: _ctx.refundClick
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('Opens in new window')), 1)
                  ]),
                  _: 1
                }, 8, ["label", "onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["rte-content"]))
}
}

})